import headBox from "./onlineClass/head.vue";
import idebox from "./onlineClass/idebox.vue";
import checkpoint from "./onlineClass/checkpoint.vue";
import store from "../store";
import { mapGetters } from "vuex";
import AdventureManager from "../manager/AdventureManager";
import OperateDom from "../manager/OperateDom";
import Cookies from "js-cookie";
import VueQr from "vue-qr";
import Logger from "../utils/Logger";
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import Const from "../const/Const";

export default {
    data() {
        return {
            canDragCodeIndexDialog: false,
            loading: false,
            createURL: process.env.GAME_CREATE_URL,
            flag: true,
            playVideoShow: true,
            ord: 0,
            blocklyOrCode: true,
            config: {
                logo: process.env.CDN_STATIC_URL + "icode.png",
            },
            zoomScale: true,
            elapseTimeTxt:0,// 倒计时时间文本
            timerId:0,
            showElapse:false,// 显示倒计时
            showEndElapse:false,// 倒计时结束
            showUnVip:false,// 显示非VIP
            showUnConfig:false,// 显示没有配置内容的
            countTotalSecs:3000,
            dialogVisible:false,
            cameraVisible:false,
            playerOptions: {
                autoplay: false,
                muted: false,
                language: 'en',
                width:'800',
                height:'426',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    // mp4
                    src: "https://static.icode.org.cn/data/default.mp4",
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                }]
            },
            canPlay:false,
            zindex:20000,
            // getQRcode:process.env.IX_IURL + "/clearance?all=1&userId=" + Cookies.get("USERID"),
        };
    },
    components: {
        idebox,
        headBox,
        checkpoint,
        VueQr,
        videoPlayer,
    },
    //VideoWaitTime-视频等待时间-数值
    //VideoURL-视频地址-字符串
    //BgAnimation-背景动画-字符串
    created() {},
    mounted() {
        // 初始化和游戏交互的类
        window.adventureManager = AdventureManager.init(this);
        // 刚进入界面时显示蒙版 (等游戏加载好了, 再移除这个蒙版)
        // store.state.maskBox = true;
        store.state.isLoading = true;
        // 载入文字变换周期
        this._loadingTextChangeInterval = 0.5;
        this._loadingTextChangeTimer = 0;
        this._loadingTextDotNumber = 3;
        // 添加事件
        this.ideResize();
        this.$nextTick(() => {
            // 窗口尺寸变化事件
            window.addEventListener("resize", () => {
                $(".codeIndexDialog_txt_zh").css("top", 0);
                $(".codeIndexDialog_txt_en").css("top", 0);
                $(".codeIndexDialog_txt_fr").css("top", 0);
                $(".codeIndexDialog_txt_sp").css("top", 0);
                this.ideResize();
            });
            // 窗口点击事件
            window.addEventListener("click", () => {
                // 如果 用户在游戏内 且 ace被蒙版蒙住，游戏画布获取焦点
                if (window._inGame && store.state.ideMask) {
                    AdventureManager.toFront_focusOnCanvas();
                }
            });
        });
        if (store.state.lang == "en"){
            this.zhShow = false;
        }else{
            this.zhShow = true;
        }
        // 预先加载图片资源
        let imgArr = [];
        for (let k in store.state.allArr) {
            imgArr.push(store.state.allArr[k].img);
        }
        for (let k in store.state.allImageMap) {
            imgArr.push(store.state.allImageMap[k]);
        }
        let loadedCount = 0;
        let totalCount = imgArr.length;
        for (let k in imgArr) {
            let img = new Image();
            img.src = imgArr[k];
            img.onload = ()=>{
                loadedCount++;
                if (loadedCount >= totalCount) {
                    store.state.imagesLoaded = true;
                }
            };
        }
        // 开始定时任务
        this.startUpdate();
        // 查看屏幕缩放比
        // let zoomRatio = this.ChangeRatio();
        // if(zoomRatio == '150'){
        //   $('.successDialog').css('transform','scale(.7)')
        //   $(".explainDialog").css('transform','translate(-50%,-50%) scale(.9)')
        // }
        // 获取摄像头

        let gameId = this.$route.query.game;
        if((gameId==2021401||gameId==2021402||gameId==2021411||gameId==2021412)){
            this.cameraVisible= true;
            this.getCameraHandler();
        }else{
            this.cameraVisible = false;
        }
    },

    destroyed() {
        // 停止定时任务
        this.stopUpdate();
    },

    methods: {
        mousedownDivHandler (e) {
            e = e || window.event;
            this.x = e.clientX - cameraVideoContainer.offsetLeft;
            this.y = e.clientY - cameraVideoContainer.offsetTop;
            this.dragFlag = true;
            this.mousemoveDivHandler(e);
            cameraVideoContainer.style.cursor="pointer";

        },
        mousemoveDivHandler (e) {
            if (this.dragFlag) {
                e = e || window.event;
                cameraVideoContainer.style.left = e.clientX - this.x + "px";
                cameraVideoContainer.style.top  = e.clientY - this.y + "px";
            }
        },
        mouseupDivHandler (event) {
            this.dragFlag = false;
            cameraVideoContainer.style.cursor="default";
        },
        getCameraHandler(){
            let constraints= {video: {width: 308, height: 192}};
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
                    this.videoSuccess(stream);
                }).catch((error)=>{
                    this.videoError(error);
                });
            }else if(navigator.webkitGetUserMedia){
                navigator.webkitGetUserMedia(constraints, (stream)=>{
                    this.videoSuccess(stream);
                }, (error)=>{
                    this.videoError(error);
                });
            }else if (navigator.mozGetUserMedia) {
                navigator.mozGetUserMedia(constraints, (stream)=>{
                   this.videoSuccess(stream);
                }, (error)=>{
                    this.videoError(error);
                });
            }else if (navigator.getUserMedia){
                navigator.getUserMedia(constraints, (stream)=>{
                    this.videoSuccess(stream);
                }, (error)=>{
                    this.videoError(error);
                });
            }
        },
        videoSuccess(stream){
            var CompatibleURL = window.URL || window.webkitURL;
            //将视频流设置为video元素的源
            // console.log(stream);
            //video.src = CompatibleURL.createObjectURL(stream);
            cameraVideo.srcObject = stream;
            cameraVideo.play();
            cameraVideo.ontimeupdate=()=>{
                // console.log("sss:"+new Date().valueOf());
            }
        },
        videoError(error){
            console.log("videoError:"+error);
        },
        setExitMode(){
            this.toggleDiv(1);
        },
        playVideoHandler(){
            if(!this.canPlay){
                return;
            }
            this.dialogVisible = true;
            if(this.$refs.videoPlayer&&this.$refs.videoPlayer.player){
                this.$refs.videoPlayer.player.play();
            }
        },
        handleClose(){
            if(this.$refs.videoPlayer&&this.$refs.videoPlayer.player){
                this.$refs.videoPlayer.player.pause();
            }
            this.dialogVisible=false;
        },
        toggleDiv(value){
            if(value==1){
                // 没有配置。不需要倒计时，UI需要制作
                this.showUnConfig = true;
                this.showUnVip = false;
                this.showElapse = false;
                this.showEndElapse =false;
                return;
            }
            if(value==2){
                // 非vip会员不能观看，UI需要处理
                this.showUnConfig = false;
                this.showUnVip = true;
                this.showElapse = false;
                this.showEndElapse =false;
                return;
            }
            if(value==3){
                // 显示倒计时
                this.showUnConfig = false;
                this.showUnVip = false;
                this.showElapse = true;
                this.showEndElapse =false;
                return;
            }
            if(value==4){
                // 倒计时结束
                this.showUnConfig = false;
                this.showUnVip = false;
                this.showElapse = false;
                this.showEndElapse =true;
                return;
            }
        },
        setConfigImg(){
            this.showUnConfig = true;
            this.showUnVip = false;
            this.showElapse = false;
            this.showEndElapse =false;
            clearInterval(this.timerId);
        },
        startCountDown(){
            let obj = window.bridge.getCurrentLevelData();
            Logger.log("start startCountDown",obj["VideoWaitTime"]);
            if(!obj["VideoWaitTime"]||obj["VideoWaitTime"]==-1){
                // 没有配置。不需要倒计时，UI需要制作
                clearInterval(this.timerId);
                this.timerId = 0;
                this.toggleDiv(1);
                return;
            }
            if(this.isVip<=0){
                // 非vip会员不能观看，UI需要处理
                Logger.log("非vip会员不能观看");
                clearInterval(this.timerId);
                this.toggleDiv(2);
                return;
            }
            // 开始倒计时
            this.playerOptions.sources[0].src = process.env.CDN_STATIC_URL+"t-video/"+window.bridge.getCurrentLevelData()['VideoURL'];
            this.countTotalSecs = parseInt(obj["VideoWaitTime"]);
            // 如果已经存在倒计时。清除并重新计时
            if(this.timerId>0){
                clearInterval(this.timerId);
                this.timerId = 0;
            }
            this.canPlay = false;// 定时器控制可以播放
            this.toggleDiv(3);
            this.timerId = setInterval(()=>{
                // 如果倒计时结束，
                if(this.countTotalSecs<=0){
                    clearInterval(this.timerId);
                    this.elapseTimeTxt = "00:00";
                    this.timerId = 0;
                    this.canPlay = true;
                    this.toggleDiv(4);
                    return;
                }
                // console.log("this.countTotalSecs",this.countTotalSecs);
                this.countTotalSecs= this.countTotalSecs- 1;
                let mins = Math.floor(this.countTotalSecs/60); // 分钟
                let secs = this.countTotalSecs%60;// 秒
                this.elapseTimeTxt = (mins<10?'0'+mins:mins)+":"+(secs<10?'0'+secs:secs);
            },1000);
        },
        initTxt(lan){
            this.$i18n.locale = lan;
            store.state.courseTitleTxt = this.$t("message.course_"+ store.state.gameId);
        },
        //
        ideResize() {
            this.screenHeight = document.body.clientHeight;
            if (this.screenHeight < 900 && this.screenHeight >= 800) {
                $(".successDialog").css("transform", "translate(-50%,-50%) scale(.8)");
                $(".explainDialog").css(
                    "transform",
                    "translate(-50%,-50%) scale(.95)"
                );
            }
            if (this.screenHeight < 800 && this.screenHeight >= 700) {
                $(".successDialog").css("transform", "translate(-50%,-50%) scale(.7)");
                $(".explainDialog").css(
                    "transform",
                    "translate(-50%,-50%) scale(.9)"
                );
            }
            if (this.screenHeight < 700) {
                $(".successDialog").css("transform", "translate(-50%,-50%) scale(.7)");
                $(".explainDialog").css(
                    "transform",
                    "translate(-50%,-50%) scale(.5)"
                );
            }
            if (this.screenHeight >= 900) {
                $(".successDialog").css("transform", "translate(-50%,-50%) scale(1)");
                $(".explainDialog").css(
                    "transform",
                    "translate(-50%,-50%) scale(1)"
                );
            }
        },
        // 操作说明图片轮播
        leftArrow() {
            let transord = this.ord - 1;
            transord = transord < 0 ? store.state.imgList.length - 1 : transord;
            this.goImg(transord);
        },
        rightArrow() {
            let transord = this.ord + 1;
            transord = transord > store.state.imgList.length - 1 ? 0 : transord;
            this.goImg(transord);
        },

        goImg(transOrd) {
            let outOrd = this.ord;
            this.ord = transOrd;
            if (this.ord > store.state.imgList.length - 1) this.ord = 0;
            let img = $(".imgBox img");
            img.eq(outOrd).animate({ opacity: 0 }, 1000);
            img.eq(this.ord).animate({ opacity: 1 }, 1000);
        },
        delImg() {
            OperateDom.getStyle(
                this.$refs.idebox.$refs.questionMark,
                store.state.allImageMap.questionMark
            );
            store.state.imgShow = false;
        },
        startUpdate() {
            this.stopUpdate();
            let dt = 1000 / 30;
            this.updateTaskId = setInterval(() => this.update(dt / 1000), dt);
        },
        checkLang(item) {
            // console.log(item)
            store.state.loadingText = this.$t("message.loading_txt") + "...";
            this.$refs.checkLangBg.style.display = "block";
            let language = "he";
            if (item == "1") {
                this.setLangs("he", "92", "172");
                language = "he";
                AdventureManager.tellGameInit("he");
            }
            if (item == "2") {
                this.setLangs("ar", "319", "172");
                language = "ar";
                AdventureManager.tellGameInit("ar");
            }
            this.$i18n.locale = language;
        },
        checkLangs(item) {
            // console.log(item)
            store.state.loadingText = this.$t("message.loading_txt") + "...";
            this.$refs.checkLangBg.style.display = "block";
            let language = "he";
            if (store.state.firstPlayVideo == "1") {
                store.state.videoShow = true;
                this.openVideo();
            }
            if (item == "1") {
                this.setLangs("he", "44", "179");
                language = "he";
                AdventureManager.tellGameInit("he");
            }
            if (item == "2") {
                this.setLangs("ar", "221", "179");
                language = "ar";
                AdventureManager.tellGameInit("ar");
            }
            if (item == "3") {
                this.setLangs("en", "398", "179");
                language = "en";
                AdventureManager.tellGameInit("en");
            }
            this.openVideo();
            this.$i18n.locale = language;
        },
        setLangs(lang, left, top) {
            // localStorage.setItem("zhOren",lang);
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", lang, { path: "/", domain: urlLan });
            this.$refs.checkLangBg.style.left = left + "px";
            this.$refs.checkLangBg.style.top = top + "px";
        },
        stopUpdate() {
            if (this.updateTaskId == null) {
                return;
            }
            clearInterval(this.updateTaskId);
        },
        // 模仿游戏组件的 update 生命期钩子
        update(dt) {
            // 更新ace中选中行的背景色
            if (window._code_is_running) {
                $(".ace_active-line").css(
                    "background",
                    window._run_code_has_exception ? "#ff4444" : "#4444ff"
                );
            }

            // 更新载入文字
            this._loadingTextChangeTimer += dt;
            if (
                this._loadingTextChangeTimer >= this._loadingTextChangeInterval
            ) {
                this._loadingTextChangeTimer = 0;
                this._loadingTextDotNumber =
                    (this._loadingTextDotNumber + 1) % 3;
                store.state.loadingText =
                    this.$t("message.loading_txt") +
                    ".".repeat(
                        this._loadingTextDotNumber == 0
                            ? 3
                            : this._loadingTextDotNumber
                    );
            }

            // 子组件的update
            this.$refs.headBox.update(dt);
            this.$refs.idebox.update(dt);
        },

        // 获取语言
        getLan() {
            return AdventureManager.getQueryString("zhOren");
        },
        // 修改语言
        changeLanguage() {
            AdventureManager.sendToGame("changeLanguage");
        },
        langDiologCancel() {
            store.state.checkLangDialogShow = false;
        },
        langDiolog() {
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", store.state.checkLangs, {
                path: "/",
                domain: urlLan,
            });
            sessionStorage.setItem("Lanauge", store.state.checkLangs);
            this.$nextTick(() => {
                window.location.reload();
            });
            // this.$i18n.locale = store.state.checkLangs;
            // Logger.log("lans",store.state.checkLangs);
            // AdventureManager.resetDefaulCode(store.state.checkLangs);
        },
        //胜利弹窗 确认
        adoptRightBtn() {
            $("button").attr("disabled", "disabled");
            AdventureManager.sendToGame("nextPass");
            Logger.log("store.state.Workspace对象====", store.state.Workspace);
            if (!Object.getOwnPropertyNames(store.state.Workspace)){
                store.state.Workspace.clear();
            }
            store.state.blPython = "";
            store.state.xml_text = "";
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.adoptDialog = false;
            store.state.adoptChinaDialog = false;
            store.state.currentIndex = false;
            $("#CanvasFrame").focus();
        },

        //胜利弹窗 取消
        adoptLeftBtn() {
            store.state.codeShow = false;
            store.state.blPython = "";
            store.state.xml_text = "";
            console.log("===================>")
            if (store.state.justLastLevel &&store.state.selectedPoint == store.state.maxHighlevel) {
                store.state.skipNextShow = true;
                store.state.adoptDialog = false;
                $("#CanvasFrame").focus();
                return;
            }
            if (store.state.isLastLevel) {
                store.state.maskBox = false;
                store.state.ideMask = false;
                store.state.adoptDialog = false;
                store.state.adoptChinaDialog = false;
                store.state.currentIndex = false;
                // 如果是体验关卡
                if(store.state.competeType==Const.COMPETE_TYPE_TOUR){
                    if(store.state.isPassAllLevel<=0){
                        store.state.tourGameNotPass = true;
                        return;
                    }
                    let alllevels = window.bridge.getTotalLevel(1);
                    // 最后一关。分数有达到20分，并且通关，
                    if(store.state.isPassAllLevel>=1&&(alllevels*2)<=store.state.totalScore){
                        store.state.tourCompelete = true;
                        store.state.customeType = 'PassTourAllLevel';
                        return;
                    }
                    store.state.tourCompeleteNotGet = true;
                    store.state.customeType = 'TourNotComplete';
                    return;
                }
                this.goToNextStage();
            } else {
                this.skipNextMethod();
            }
        },
        goToNextStage(){
            $("#CanvasFrame").focus();
            AdventureManager.sendToGame("nextPass");
        },
        skipNextBtn() {
            this.skipNextMethod();
            store.state.skipNextShow = false;
        },
        //回到过去弹窗
        skipNextMethod() {
            AdventureManager.sendToGame("goBack");
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.adoptDialog = false;
            $("#CanvasFrame").focus();
        },
        continueCurrentTourHandler(){
            window.location.reload();
        },
        //错误弹窗 取消
        failCancelClick() {
            store.state.skipStyleShow = true;
            if (store.state.customeType == "ResetCode") {
                // store.state.skipStyleShow = false;
            } else if (store.state.customeType == "ExitGame") {
                store.state.ideMask = false;
            } else if (store.state.customeType == "Glossary") {
                store.state.ideMask = false;
            } else if (store.state.customeType == "PassAllLevel") {
                store.state.ideMask = false;
                this.logOut();
            } else {
                store.state.ideMask = false;
                AdventureManager.sendToGame("goBack");
            }
            store.state.maskBox = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state.exitGameMode = false;
            store.state._resetCodeOpened = false;
            setTimeout(() => {
                store.state.toBack = false;
            }, 500);
            store.state.customeType == null;
            $("#CanvasFrame").focus();
        },
        failAcceptSkip() {
            store.state.blPython = "";
            store.state.xml_text = "";
            $("button").attr("disabled", "disabled");
            AdventureManager.sendToGame("skipToNext");
            if (store.state.chooseMode == "0"){
                store.state.Workspace.clear();
            }
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state.exitGameMode = false;
            store.state.currentIndex = true;
        },
        // 中文版本 最后成功
        failCancelClickChina() {
            store.state.ideMask = false;
            store.state.maskBox = false;
            store.state.adoptChinaDialog = false;
            AdventureManager.checkPonit(store.state.selectedPoint);
        },

        //错误弹窗 确认
        failAcceptClick() {
            store.state.blPython = "";
            store.state.xml_text = "";
            store.state.skipStyleShow = true;
            store.state.skipShow = false;
            if (store.state.customeType == "ResetCode") {
                AdventureManager.sendToGame("acceptRestCodeDialog");
            } else if (store.state.customeType == "ExitGame") {
                this.logOut();
            } else if (store.state.customeType == "Glossary") {
                Logger.log("Glossary");
            } else if (store.state.customeType == "PassAllLevel") {
                this.logOut();
            } else {
                AdventureManager.sendToGame("goBack");
            }
            setTimeout(() => {
                store.state.toBack = false;
            }, 500);
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.failDialog = false;
            store.state.failDialogChina = false;
            store.state._resetCodeOpened = false;
            store.state.customeType == null;
            $("#CanvasFrame").focus();
        },

        // 欢迎弹窗确认
        welcomeDialogConfirm() {
            store.state.maskBox = false;
            store.state.ideMask = false;
            store.state.welcomeDialog = false;
        },
        // 关闭提示
        codeIndexDialogClose() {
            store.state.maskBox = false;
            store.state.codeIndexDialog = false;
        },
        //
        explainDialogHide() {
            store.state.explainDialog = false;
        },
        logOut() {
            // let lang = AdventureManager.getQueryString("zhOren") || localStorage.getItem("zhOren");

            //alert(window.bridge.getIsTmpMode());
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", store.state.lang, {
                path: "/",
                domain: urlLan,
            });
            let url = AdventureManager.getHomePage();
            window.location.href = url;
            // window.close();
        },
        sessionOut() {
            window.location.href = "about:blank";
            window.close();
        },
        linkToPub() {
            // window.location.href = 'https://pub.skillz-edu.org/portal/';
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", store.state.lang, {
                path: "/",
                domain: urlLan,
            });
            window.location.href = AdventureManager.getSignPage();
        },
        linkToMonthly() {
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", store.state.lang, {
                path: "/",
                domain: urlLan,
            });
            window.location.href = process.env.GAME_MONTH_URL;
        },
        linkToFinals() {
            let urlLan = process.env.ROOT_DOMAIN;
            Cookies.set("zhOren", store.state.lang, {
                path: "/",
                domain: urlLan,
            });
            window.location.href = AdventureManager.getFinalPage();
        },
        ended() {
            store.state.videoShow = false;
        },
        delVideo() {
            $(".videoShow").remove();
            store.state.videoShow = false;
            store.state.maskBox = false;
        },
        openVideo() {
            var video = document.getElementById("video");
            video.play();
        },
        exitBrower() {
            window.location.href = "about:blank";
            window.close();
        },
        playVideo() {
            this.playVideoShow = false;
            this.openVideo();
        },
        delWelcome() {
            store.state.welcomeDialogShow = false;
        },
        delPassAll() {
            store.state.passAllLevelShow = false;
            AdventureManager.getGameInfo();
            setTimeout(() => {
                store.state.qrCodeShow2 = false;
            }, 500);
        },
        interfaceAgian() {
            OperateDom.getStyle(
                this.$refs.interfaceErrorBtn,
                store.state.allImageMap.shadow_reload
            );
            setTimeout(() => {
                window.location.reload();
                store.state.interfaceErrorShow = false;
            }, 1000);
        },
        // listen event
        onPlayerPlay(player) {
            // console.log('player play!', player)
        },
        onPlayerPause(player) {
            // console.log('player pause!', player)
        },
        onPlayerEnded(player) {
            // console.log('player ended!', player)
        },
        onPlayerLoadeddata(player) {
            // console.log('player Loadeddata!', player)
        },
        onPlayerWaiting(player) {
            // console.log('player Waiting!', player)
        },
        onPlayerPlaying(player) {
            // console.log('player Playing!', player)
        },
        onPlayerTimeupdate(player) {
            // console.log('player Timeupdate!', player.currentTime())
        },
        onPlayerCanplay(player) {
            // console.log('player Canplay!', player)
        },
        onPlayerCanplaythrough(player) {
            player.play();
            // console.log('player Canplaythrough!', player)
        },
        // or listen state event
        playerStateChanged(playerCurrentState) {
            // console.log('player current update state', playerCurrentState)
        },
        // player is ready
        playerReadied(player) {
            // seek to 10s
            Logger.log('example player 1 readied', player)
            player.currentTime(10)
            // console.log('example 01: the player is readied', player)
        },
        continueCurrentTour(value){
            store.state.tourNotCompelete = false;
            store.state.tourCompeleteNotGet = false;
            store.state.tourGameNotPass = false;
            if(value==1){
                AdventureManager.sendToGame("nextPass");
                Logger.log("continue current game");
            }
        },
        quitCurrentToure(value){
            Logger.log("quitCurrentToure "+value);
            if(value==1){
                // 成功创关,领奖
                // goto tour main page
                window.location.href = process.env.ONE_HOUR_GET_PRIZE_URL+"?game="+window.bridge.getCurrentGameId();
                return;
            }
            window.location.href = process.env.ONE_HOUR_URL;
            //goto tour main page
        }
    },
    computed: {
        ...mapGetters([
            "maskBox",
            "adoptDialog",
            "failDialog",
            "welcomeDialog",
            "adoptTitle",
            "adoptText",
            "failTitle",
            "failText",
            "customeType",
            "isLoading",
            "imagesLoaded",
            "loadingText",
            "codeIndexDialog",
            "allImageMap",
            "allArr",
            "adoptChinaDialog",
            "failDialogChina",
            "exitGameMode",
            "checkpointShow",
            "explainDialog",
            "configLine",
            "configSteps",
            "curLine",
            "curSteps",
            "star",
            "toBack",
            "skipShow",
            "knowledgeArr",
            "allStar",
            "dirLang",
            "sessionShow",
            "explainDialog1",
            "explainDialog2",
            "videoShow",
            "checkLangShow",
            "highCheckShow",
            "imgShow",
            "imgList",
            "browserVersionShow",
            "highLevelShow",
            "lang",
            "welcomeDialogShow",
            "passAllLevelShow",
            "interfaceErrorShow",
            "isPassAllLevel",
            "skipStyleShow",
            "skipNextShow",
            "qrCodeUrl",
            "qrCodeShow",
            "getQRcode",
            "qrCodeShow2",
            "codeShow",
            "chooseMode",
            "blocklyShow",
            "justLastLevel",
            "checkLangDialogShow",
            "checkLangs",
            "monthlyGameShow",
            "ipShow",
            "timeoverShow",
            "isVip",
            "tourNotCompelete",
            "tourCompelete",
            "tourCompeleteNotGet",
            "tourGameNotPass",
            "pathAllImage",
            "icode_qq_txt"
        ]),
        delVideos() {
            if (window.screenLeft == 0 &&window.document.body.clientWidth == window.screen.width){
                return false;
            }
            return true;
        },
        qrCodeUrlM() {
            return store.state.qrCodeUrl;
        },
        zhShow() {
            if (store.state.lang == "en") {
                return false;
            } else {
                return true;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/online-class.js